import * as Enumerable from 'linq';

export interface DateFormat {
    id: string;
    name: string;
}

export interface DateFormatGroup {
    name: string;
    formats: DateFormat[];
}


export class DateFormatUtility {

    public static getDateFormats(seperator = '/'): DateFormat[] {

        const mediumFormats = [
            'dd.MM.yyyy',
            'MM.dd.yyyy',
            'yyyy.MM.dd'
        ];

        return Enumerable
            .from(mediumFormats)
            .select(x => {
                const formatted = this.replaceAll(x, '.', seperator);
                return {
                    id: formatted,
                    name: formatted
                };
            }).toArray();

    }

    public static getDefaultDateFormat(seperator = '/') {
        return Enumerable.from(this.getDateFormats(seperator)).select(x => x.id).firstOrDefault();
    }

    public static getTimeFormats(): DateFormat[] {

        const mediumFormats = [
            'hh:mm a',
            'HH:mm'
        ];

        return Enumerable
            .from(mediumFormats)
            .select(x => {
                return {
                    id: x,
                    name: x
                };
            }).toArray();

    }

    public static getDefaultTimeFormat() {
        return Enumerable.from(this.getTimeFormats()).select(x => x.id).firstOrDefault();
    }

    private static replaceAll(data: string, find: string, replace: string) {
        return data.split(find).join(replace);
    }

}
